export const isPWAInstalled = () => {
  // Check standard display-mode (works on most modern browsers)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }
  // Check iOS Safari specific property
  if ('standalone' in window.navigator && window.navigator.standalone === true) {
    return true;
  }
  return false;
};
